const ViewIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12.823" height="7.328" viewBox="0 0 12.823 7.328">
      <g>
        <path fill={'currentColor'} d="M38.412,128c-2.344,0-4.17,1.4-6.412,3.664,1.929,1.938,3.549,3.664,6.412,3.664s4.963-2.187,6.412-3.624C43.341,130.021,41.24,128,38.412,128Zm0,6.277a2.614,2.614,0,1,1,2.565-2.613A2.593,2.593,0,0,1,38.412,134.277Z" transform="translate(-32 -128)"/>
        <path fill={'currentColor'} d="M205.2,203.31a.919.919,0,0,1,.217-.593,1.366,1.366,0,0,0-.217-.017,1.526,1.526,0,1,0,1.5,1.526c0-.066-.006-.132-.011-.2a.917.917,0,0,1-1.486-.718Z" transform="translate(-198.785 -200.562)"/>
      </g>
    </svg>
  );
};

export default ViewIcon;
